<!-- 审核 -->
<template>
  <div class="diseaseList">
    <el-form :inline="true">
        <el-form-item label="账户号码: " style="margin-right:10px" size="small">
          <el-input v-model="listQuery.vip_number" placeholder="请输入" clearable></el-input>
        </el-form-item>

        <el-form-item label="交易类型:" style="margin-right:10px" size="small">
          <el-select v-model="listQuery.moneyRange" placeholder="请选择" clearable>
            <div v-for="(item, index) in moneyTypeList" :key="index">
              <el-option :label="item.name" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item>

        <el-form-item label="手机号: " style="margin-right:10px" size="small">
          <el-input v-model="listQuery.user_phone" placeholder="请输入" clearable></el-input>
        </el-form-item>

        <el-form-item label="交易描述: " style="margin-right:10px" size="small">
          <el-input v-model="listQuery.message" placeholder="请输入" clearable></el-input>
        </el-form-item>
        <el-button type="primary" @click="getListData" size="small" v-waves>搜索</el-button>
      </el-form>
    <div class="tableList">
      <ElTable
        :columns="listHeader"
        :tableData="tableData"
        :loading="loading"
        :total="listQuery.total"
        @handleCurrentChange="handleCurrentChange"
        @handleSizeChange="handleSizeChange"
      >
     <template slot="admin_id" slot-scope="{ row }">
          {{
          arrayByIdToNameStr({
          ArrayData: accountList,
          ID: row.admin_id,
          })
          }}
        </template>
        <template slot="amount" slot-scope="{ row }">
          <el-tag v-if="row.amount < 0" type="danger" effect="dark" size="mini">{{ row.amount }}</el-tag>
          <el-tag v-else type="success" effect="dark" size="mini">{{ row.amount }}</el-tag>
        </template>
        <template slot="type" slot-scope="{ row }">
          <el-tag v-if="row.type === '企业账户余量'" type="success" effect="dark" size="mini">企业账户余量</el-tag>
          <el-tag v-else-if="row.type === '惠信宝'" effect="dark" size="mini">惠信宝</el-tag>
        </template>
        <template slot="operation" slot-scope="{ row }">
          <div class="operation">
            <el-button
              size="mini"
              type="text"
              style="color: rgb(255, 0, 0);"
              @click="handleDelete(row)"
            >删除</el-button>
          </div>
        </template>
      </ElTable>
    </div>
  </div>
</template>

<script>
import ElTable from "@/components/elTable/index.vue";
import listHeader from "./listHeader";
import filterQueryFormItems from "./filterQueryFormItems";
import StoreToString from "@/components/filters/storeToString.vue";
import {
  selectVipcardRecoder,
  deleteVipcardRecoder
} from "@/services/mall/vipcardRecode";
import { mapState } from "vuex";
import { selectAdmin } from "@/services/system/user.js";
import { arrayByIdToNameStr } from "@/utils/arrayByIdToNameStr";
export default {
  components: {
    ElTable,
    StoreToString
  },
  async created() {
    this.getListData();
    this.selectAccountList()
  },
  data() {
    return {
      arrayByIdToNameStr,
      moneyTypeList: [
        { id: 1, name: "充值" },
        { id: 2, name: "消费" }
      ],
      loading: false,
      listQuery: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      /* 表格数据 */
      tableData: [],
      accountList: []
    };
  },
  computed: {
    filterQueryFormItems,
    listHeader,
    ...mapState(["userInfo", "filterStoreList"])
  },
  watch: {},
  methods: {
    async selectAccountList() {
      const { data, code, count } = await selectAdmin({
        pageNumber: 1,
        pageSize: 1000,
        grade: "1,2"
      });
      if (code === 200) {
        this.accountList = data.map(item => {
          return {
            ...item,
            name: item.alias_name,
            id: item.id
          };
        });
      }
    },
    async getListData() {
      let listQuery = JSON.parse(JSON.stringify(this.listQuery));
      // listQuery.store_id =
      //   listQuery.store_id?.join(",") || this.userInfo.store_id;
      this.loading = true;
      const { data, code, count } = await selectVipcardRecoder({
        ...listQuery,
        admin_id: this.userInfo.id,
        // grade: this.userInfo.grade,
      });
      if (code === 200) {
        this.tableData = data;
        this.listQuery.total = count;
        setTimeout(() => {
          this.loading = false;
        }, 600);
      }
    },
    /* 搜索按钮 */
    async search(listQuery) {
      this.listQuery = listQuery;
      this.getListData();
    },
    /* 分页 */
    handleCurrentChange(e) {
      console.log(e);
      this.listQuery.pageNumber = e;
      this.getListData();
    },
    handleSizeChange(e) {
      console.log(e);
      this.listQuery.pageSize = e;
      this.getListData();
    },

    /* 删除 */
    handleDelete(row) {
      this.$confirm(`确定删除该记录吗?`, "禁用", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(res => {
        deleteVipcardRecoder({ id: row.id }).then(res => {
          if (res.code === 200) {
            this.getListData();
            this.$message({
              type: "success",
              message: "删除成功!"
            });
          }
        });
      });
    }
  }
};
</script>

<style scoped lang="less">
.diseaseList {
  width: 100%;
}
.selectForm {
  background: #fff;
  // max-width: 1405px;
  padding: 10px 0;
  margin: 10px auto;
}
.tableList {
  border-radius: 6px;
  background: #fff;
  // max-width: 1405px;
  margin: 10px auto;
}

.operation {
  a {
    margin-right: 10px;
  }
}
</style>
